import Actions from 'flow/actions';
import { fromJS, List, Map } from 'immutable';
import { listToMap } from 'flow/utils';

const initialState = Map();

// The widget keeps which calls it shows and when they came in and ended. The
// rows read each call itself from the call-records store.
const CALL_ENTRY_FIELDS = new Set(['key', 'connected', 'disconnected']);

export const CentralSwitchWidgetsReducer = (
    state = initialState,
    action: any,
) => {
    switch (action.type) {
        case Actions.CLEAR_STATE: {
            return initialState;
        }
        case Actions.RESULT_QUEUE_CALL_RECORDS_UNHANDLED_WIDGET: {
            const fetchedCallRecordsData = fromJS(action.data);
            const fetchedRecords = fetchedCallRecordsData.get(
                'records',
                List(),
            );
            const mappedFetchedRecords = listToMap(
                fetchedRecords,
                (item: any) => item.get('key'),
            ).map((record: Map<string, unknown>) =>
                record.filter((_value, field) => CALL_ENTRY_FIELDS.has(field)),
            );
            if (
                action.overwriteExistingData ||
                !state.getIn(['unhandledQueueCalls', 'records'])
            ) {
                return state.setIn(
                    ['unhandledQueueCalls', 'records'],
                    mappedFetchedRecords,
                );
            }
            return state.mergeIn(
                ['unhandledQueueCalls', 'records'],
                mappedFetchedRecords,
            );
            //Not storing since/before atm; one page at a time for now
        }
        case Actions.RESULT_CREATE_CALL_ACTION: {
            if (action.data.name !== 'handle-unanswered') return state;

            return state.deleteIn([
                'unhandledQueueCalls',
                'records',
                action.callRecordKey,
            ]);
        }
        default:
            return state;
    }
};

export default CentralSwitchWidgetsReducer;
